import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import React, { useState, type JSX } from 'react';
import { Gutachtenart, RechnungspositionEinheit } from '../../shared/constants';
import { Mandant, VorgangRechnungspositionEintrag } from '../../types';
import { Modal } from '../Modal';
import { RechnungspositionenTabelle } from '../RechnungspositionenTabelle';
import Bestaetigungsdialog from './Bestaetigungsdialog';
import './RechnungspositonenEditierenDialog.css';

const addButton = {
  display: 'flex',
  marginTop: '1rem',
  justifyContent: 'center'
};

type Props = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly reihenfolgeAenderbar: boolean;
  readonly rechnungsparameter: VorgangRechnungspositionEintrag[];
  readonly mandant: Mandant | null;
  readonly gutachtenart: Gutachtenart;
  readonly aktualisiereRechnungspositionen: (rechnungspositionen: VorgangRechnungspositionEintrag[]) => void;
  readonly isLoading: boolean;
  readonly geaendetePositionen: boolean;
  readonly saveButtonLabel?: string;
};

export function RechnungspositonenEditierenDialog({
  open,
  onClose,
  reihenfolgeAenderbar,
  rechnungsparameter,
  mandant,
  gutachtenart,
  aktualisiereRechnungspositionen,
  isLoading,
  geaendetePositionen,
  saveButtonLabel = 'Speichern'
}: Props): JSX.Element {
  const [rechnungspositionen, setRechnungspositionen] = useState<VorgangRechnungspositionEintrag[]>(
    rechnungsparameter ?? ([] as Array<VorgangRechnungspositionEintrag>)
  );

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openDeleteAllDialog, setOpenDeleteAllDialog] = useState(false);

  const [loeschenIndex, setLoeschenIndex] = useState<number>(-1);

  const loescheEintrag = (index: number) => {
    if (geaendetePositionen) {
      setRechnungspositionen(rechnungspositionen.filter((r, i) => i !== index));
    } else {
      setRechnungspositionen(rechnungspositionen.map((r, i) => (i === index ? { ...r, geloescht: true } : r)));
    }
    setLoeschenIndex(-1);
  };
  const fuegeNeuePositionHinzu = () => {
    setRechnungspositionen((state) => [
      ...state,
      {
        titel: '',
        einheit: RechnungspositionEinheit.EURO,
        wert: 0,
        anzahl: 1,
        summe: 0
      }
    ]);
  };

  return (
    <>
      <Modal
        openModal={open}
        setOpenModal={onClose}
        title="Rechnungspositionen"
        body={
          <Grid container>
            <Grid size={12}>
              <RechnungspositionenTabelle
                reihenfolgeAenderbar={reihenfolgeAenderbar}
                rechnungsparameter={rechnungspositionen}
                setRechnungsparameter={setRechnungspositionen}
                mandant={mandant}
                gutachtenart={gutachtenart}
                positionenAenderbar={false}
                positionenLoeschbar={true}
              />
            </Grid>
            <Grid size={12} sx={addButton}>
              <IconButton color="primary" onClick={fuegeNeuePositionHinzu} data-testid="hinzufuegen" size="large">
                <AddIcon />
              </IconButton>
            </Grid>
          </Grid>
        }
        footer={
          <Grid container display="flex" justifyContent="space-between" width="100%">
            <Grid>
              <Button autoFocus onClick={onClose} variant="contained" color="secondary">
                Abbrechen
              </Button>
            </Grid>
            <Grid>
              <Button disabled={isLoading} variant="contained" color="error" data-testid="alleEintraegeLoeschen" onClick={() => setOpenDeleteAllDialog(true)}>
                Alle Einträge löschen
              </Button>
            </Grid>

            <Grid>
              <Button
                disabled={isLoading}
                variant="contained"
                color="primary"
                data-testid="speichern"
                onClick={() => aktualisiereRechnungspositionen(rechnungspositionen)}
              >
                {saveButtonLabel}
              </Button>
            </Grid>
          </Grid>
        }
      />
      <Bestaetigungsdialog
        title="Eintrag löschen"
        text="Möchten Sie den Eintrag wirklich löschen?"
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        onDelete={() => {
          loescheEintrag(loeschenIndex);
          setOpenDeleteDialog(false);
        }}
      />
      <Bestaetigungsdialog
        title="Alle Einträge löschen"
        text="Möchten Sie alle Einträge wirklich löschen?"
        open={openDeleteAllDialog}
        onClose={() => setOpenDeleteAllDialog(false)}
        onDelete={() => {
          setRechnungspositionen([]);
          setOpenDeleteAllDialog(false);
        }}
      />
    </>
  );
}
